export default "__VITE_ASSET__59022396__"